"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cities = [
    {
        code: 'vilnius',
        name: 'Vilnius',
        country: 'LT',
        currency: 'EUR',
        defaultAreaRadius: 20000,
        language: 'lt',
        location: { lat: 54.687157, lng: 25.279652 },
    },
    {
        code: 'kaunas',
        name: 'Kaunas',
        country: 'LT',
        currency: 'EUR',
        defaultAreaRadius: 20000,
        language: 'lt',
        location: { lat: 54.898521, lng: 23.903597 },
    },
    {
        code: 'klaipeda',
        name: 'Klaipėda',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        location: { lat: 55.703297, lng: 21.144279 },
    },
    {
        code: 'alytus',
        name: 'Alytus',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 54.396294, lng: 24.045876 },
    },
    {
        code: 'anyksciai',
        name: 'Anykščiai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.529102, lng: 25.113186 },
    },
    {
        code: 'birzai',
        name: 'Biržai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 56.201772, lng: 24.756012 },
    },
    {
        code: 'druskininkai',
        name: 'Druskininkai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 54.004907, lng: 23.986428 },
    },
    {
        code: 'elektrenai',
        name: 'Elektrėnai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 54.785812, lng: 24.66247 },
    },
    {
        code: 'ignalina',
        name: 'Ignalina',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.334688, lng: 26.165916 },
    },
    {
        code: 'jonava',
        name: 'Jonava',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.072724, lng: 24.279334 },
    },
    {
        code: 'joniskis',
        name: 'Joniškis',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 56.236073, lng: 23.613658 },
    },
    {
        code: 'jurbarkas',
        name: 'Jurbarkas',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.077407, lng: 22.741957 },
    },
    {
        code: 'kedainiai',
        name: 'Kėdainiai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.287899, lng: 23.974739 },
    },
    {
        code: 'kupiskis',
        name: 'Kupiškis',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.838839, lng: 24.980148 },
    },
    {
        code: 'kursenai',
        name: 'Kuršėnai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.997525, lng: 22.936727 },
    },
    {
        code: 'marijampole',
        name: 'Marijampolė',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.enableMarijampoleLocation',
        location: { lat: 54.56667, lng: 23.35 },
    },
    {
        code: 'mazeikiai',
        name: 'Mažeikiai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.enableMazeikiaiLocation',
        location: { lat: 56.31667, lng: 22.33333 },
    },
    {
        code: 'moletai',
        name: 'Molėtai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.22469, lng: 25.41688 },
    },
    {
        code: 'palanga',
        name: 'Palanga',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.920198, lng: 21.067761 },
    },
    {
        code: 'pasvalys',
        name: 'Pasvalys',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 56.060462, lng: 24.396291 },
    },
    {
        code: 'panevezys',
        name: 'Panevėžys',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.enablePanevezysLocation',
        location: { lat: 55.73333, lng: 24.35 },
    },
    {
        code: 'plunge',
        name: 'Plungė',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.91139, lng: 21.84417 },
    },
    {
        code: 'raseiniai',
        name: 'Raseiniai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.37361, lng: 23.12167 },
    },
    {
        code: 'rokiskis',
        name: 'Rokiškis',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.955504, lng: 25.585925 },
    },
    {
        code: 'siauliai',
        name: 'Šiauliai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.enableSiauliaiLocation',
        location: { lat: 55.93333, lng: 23.31667 },
    },
    {
        code: 'silute',
        name: 'Šilutė',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.350414, lng: 21.465986 },
    },
    {
        code: 'taurage',
        name: 'Tauragė',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.27126, lng: 22.29645 },
    },
    {
        code: 'telsiai',
        name: 'Telšiai',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.983582, lng: 22.250811 },
    },
    {
        code: 'ukmrege',
        name: 'Ukmergė',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        location: { lat: 55.25, lng: 24.75 },
        toggle: 'app.enableUkmergeLocation',
    },
    {
        code: 'utena',
        name: 'Utena',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.enableUtenaLocation',
        location: { lat: 55.5, lng: 25.6 },
    },
    {
        code: 'varena',
        name: 'Varėna',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 54.21667, lng: 24.56667 },
    },
    {
        code: 'visaginas',
        name: 'Visaginas',
        country: 'LT',
        currency: 'EUR',
        language: 'lt',
        defaultAreaRadius: 20000,
        toggle: 'app.ltFullCoverage',
        location: { lat: 55.597276, lng: 26.431317 },
    },
    {
        code: 'warsaw',
        name: 'Warszawa',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 52.229676, lng: 21.012229 },
    },
    {
        hidden: true,
        code: 'krakow',
        name: 'Kraków',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 50.06465, lng: 19.94498 },
        toggle: 'app.enableKrakowLocation',
    },
    {
        hidden: true,
        code: 'metropolisGzm',
        name: 'Metropolia',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 50.332968, lng: 18.960124 },
        toggle: 'app.enableMetrololisGzmLocation',
        regions: [
            {
                code: 'bedzin',
                name: 'Będzin',
                defaultAreaRadius: 20000,
                location: { lat: 50.3256, lng: 19.125412 },
            },
            {
                code: 'bytom',
                name: 'Bytom',
                defaultAreaRadius: 20000,
                location: { lat: 50.348382, lng: 18.915718 },
            },
            {
                code: 'chorzów',
                name: 'Chorzów',
                defaultAreaRadius: 20000,
                location: { lat: 50.2974488, lng: 18.954573 },
            },
            {
                code: 'dabrowa',
                name: 'Dąbrowa Górnicza',
                defaultAreaRadius: 20000,
                location: { lat: 50.32169, lng: 19.194913 },
            },
            {
                code: 'gliwice',
                name: 'Gliwice',
                defaultAreaRadius: 20000,
                location: { lat: 50.294492, lng: 18.67138 },
            },
            {
                code: 'katowice',
                name: 'Katowice',
                defaultAreaRadius: 20000,
                location: { lat: 50.264892, lng: 19.023782 },
            },
            {
                code: 'myslowice',
                name: 'Mysłowice',
                defaultAreaRadius: 20000,
                location: { lat: 50.208047, lng: 19.166051 },
            },
            {
                code: 'rudaSlaska',
                name: 'Ruda Śląska',
                defaultAreaRadius: 20000,
                location: { lat: 50.255829, lng: 18.85557 },
            },
            {
                code: 'siemianowice',
                name: 'Siemianowice Śląskie',
                defaultAreaRadius: 20000,
                location: { lat: 50.326431, lng: 19.029571 },
            },
            {
                code: 'sosnowiec',
                name: 'Sosnowiec',
                defaultAreaRadius: 20000,
                location: { lat: 50.286264, lng: 19.104079 },
            },
            {
                code: 'zabrze',
                name: 'Zabrze',
                defaultAreaRadius: 20000,
                location: { lat: 50.324928, lng: 18.785719 },
            },
        ],
    },
    {
        hidden: true,
        code: 'wroclaw',
        name: 'Wrocław',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 51.107885, lng: 17.038538 },
        toggle: 'app.enableWroclawLocation',
    },
    {
        hidden: true,
        code: 'poznan',
        name: 'Poznań',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 52.406374, lng: 16.925168 },
        toggle: 'app.enablePoznanLocation',
    },
    {
        hidden: true,
        code: 'gdansk',
        name: 'Gdańsk',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 54.352025, lng: 18.646638 },
        toggle: 'app.enableGdanskLocation',
    },
    {
        hidden: true,
        code: 'lodz',
        name: 'Łódź',
        country: 'PL',
        currency: 'PLN',
        language: 'pl',
        defaultAreaRadius: 20000,
        location: { lat: 51.759249, lng: 19.455983 },
        toggle: 'app.enableLodzLocation',
    },
];
exports.default = cities;
//# sourceMappingURL=cities.js.map